<template>
  <span
    data-cy="custom-form-submission-status-chip"
    :class="[
      'inline-flex h-6 shrink-0 items-center whitespace-nowrap rounded-full px-3',
      'text-xs font-medium',
      chip.class
    ]"
  >
    {{ chip.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { CustomFormSubmissionStatus } from "@/typings/customForm";

// Separate from CustomFormStatusChip, which labels a *template's* lifecycle
// (published/draft/archived) — an unrelated vocabulary that shared one silent
// fallback would serve wrongly. Colours track the tech app's chip.
const props = defineProps<{ status: CustomFormSubmissionStatus | string }>();

const CHIPS: Record<
  CustomFormSubmissionStatus,
  { label: string; class: string }
> = {
  in_progress: {
    label: "In progress",
    class: "bg-primary-50 text-primary-700"
  },
  submitted: { label: "Submitted", class: "bg-green-50 text-green-700" }
};

// An unrecognised status renders itself rather than claiming a state the server
// did not report.
const chip = computed(
  () =>
    CHIPS[props.status as CustomFormSubmissionStatus] ?? {
      label: props.status,
      class: "bg-gray-100 text-gray-600"
    }
);
</script>
